<template>
    <div>
        <Section title="POI审核管理">

            <FilterBox :item-right="40" inline border style="padding: 20px;">
                <FilterBoxItem>
                    <Input style="width: 200px" placeholder='POI名称/POIID'/>
                </FilterBoxItem>

                <FilterBoxItem label="所属楼层">
                    <Select style="width: 100px" value="all">
                        <Option value="all">
                            全部
                        </Option>
                        <Option value="00230029F01">
                            F1
                        </Option>
                        <Option value="00230029F02">
                            F2
                        </Option>
                    </Select>
                </FilterBoxItem>

                <FilterBoxItem label="状态">
                    <Select style="width: 100px" value="0">
                        <Option value="0">
                            全部
                        </Option>
                        <Option value="1">
                            正常
                        </Option>
                        <Option value="2">
                            待审核
                        </Option>
                    </Select>
                </FilterBoxItem>

                <FilterBoxItem label="所属类型" :item-right="20">
                    <Select style="width: 100px" value="0">
                        <Option value="0">
                            全部
                        </Option>
                        <Option value="1">
                            商铺
                        </Option>
                        <Option value="2">
                            公共设施
                        </Option>
                    </Select>
                </FilterBoxItem>

                <FilterBoxItem>
                    <Button type="primary">
                        查找
                    </Button>
                </FilterBoxItem>

            </FilterBox>

            <LabelHeader border>
                <div slot="before" class="colorA2 fs-12px">
                    全部POI列表<span class="colorA3 ml-5px">(共<b style="color: #FF3300">2300</b>条，已筛选<b style="color: #FF3300">66</b>条，已勾选<b style="color: #FF3300">6</b>条)</span>
                    <span class="ml-20px">
                        <Button type="primary" class="mr-15px">批量审核通过</Button>
                        <Button type="error">批量审核失败</Button>
                    </span>
                </div>
            </LabelHeader>


            <div style="padding: 20px">
                <Table border :columns="columns" :data="data"></Table>
                <Page :total="100" :page-size="10" style="text-align: right; margin-top: 20px"></Page>
            </div>
        </Section>
    </div>
</template>

<script>

    import LabelHeader from '@/modules/LabelHeader'

    import FilterBox from '@/modules/FilterBox';
    import FilterBoxItem from '@/modules/FilterBoxItem';

    import { Table, Page, Button, Input, Select, Option } from 'iview';

    export default {
        name: "TTable1",
        data () {
            return {
                columns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '最近修改时间',
                        key: 'updateTime',
                        align: 'center',
                        minWidth: 200
                    },
                    {
                        title: 'POI名称',
                        key: 'poiName',
                        align: 'center',
                        minWidth: 200
                    },
                    {
                        title: '所属楼层',
                        key: 'floorName',
                        align: 'center',
                        minWidth: 100
                    },
                    {
                        title: 'POIID',
                        key: 'poiId',
                        align: 'center',
                        minWidth: 150
                    },
                    {
                        title: '状态',
                        align: 'center',
                        minWidth: 100,
                        render: (h, params) => {
                            if(params.row.state === 1) {
                                return h('span', {style:{color: '#FF3300'}}, '待审核')
                            }
                            else {
                                return h('span', {}, '正常')
                            }
                        }
                    },
                    {
                        title: '操作',
                        width: 200,
                        render: (h, params) => {

                            let btnStyle = {
                                padding: '0 10px'
                            };

                            return h('div', [
                                h('a', {style: btnStyle}, '编辑'),
                                h('a', {style: btnStyle}, '查看详情')
                            ]);
                        }
                    }
                ],
                data: []
            }
        },
        mounted () {

            let data = [];

            for(let i = 0; i < 10; i++) {
                data.push({
                    no: i,
                    updateTime: '2019-2-13 12:11:29',
                    poiName: '智石科技',
                    floorName: 'F1',
                    poiId: '00230029F011115',
                    state: 1
                })
            }

            this.data = data;

        },

        components: {
            LabelHeader,
            FilterBox,
            FilterBoxItem,
            Table,
            Button,
            Page,
            Input,
            Select,
            Option,
        }
    }
</script>

<style scoped>
</style>
